module.exports = __webpack_public_path__ + "static/media/my-family-campaign-banner-mobile.6b4975bc.jpg";